"use strict";

class PropertyLinksController {
    constructor($scope, $rootScope, $localStorage, $timeout, $window, SSHttpService, SSUtilService, SSAppService, SSUserService, SSDisclaimerService) {

        const self = this;

        self.$scope = $scope;
        self.$rootScope = $rootScope;
        self.$storage = $localStorage;
        self.$timeout = $timeout;
        self.$window = $window;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSUserService = SSUserService;
        self.SSDisclaimerService = SSDisclaimerService;

        self.data = SHOWSUITE.data;
        self.property = self.data.property;

        self.PROPERTY_ASSET_TYPE_360_IMAGE = SHOWSUITE.PROPERTY_ASSET_TYPE_360_IMAGE;
        self.FLOORPLAN_ASSET_TYPE_360_IMAGE = SHOWSUITE.FLOORPLAN_ASSET_TYPE_360_IMAGE;

        self.init();
    }

    init() {
        const self = this;

        self.LOADING = true;

        self.prepareAssetsUrl();
    }

    prepareAssetsUrl(){
        const self = this;

        self.asset_url = null;

        //Prepare 360 photos
        if (self.property.property_assets) {
            self.property.assets360Imgs = self.property.property_assets.filter(x => x.type === self.PROPERTY_ASSET_TYPE_360_IMAGE);
        }

        if(self.data.unit && self.data.unit.unit_assets){
            self.data.unit.assets360Imgs = self.data.unit.unit_assets.filter(x => x.type === self.FLOORPLAN_ASSET_TYPE_360_IMAGE);
        }

        if (SHOWSUITE.data.view_mode) {
                
            switch(SHOWSUITE.data.view_mode) {
                case '3dmodel_a':
                    self.asset_url = self.property.model_3d ? self.property.model_3d : null;
                    self.show3dView(self.property.id, { property_id: self.property.id, property_type: "property" });
                    break;

                case '360_a':
                    self.asset_url = (self.property.assets360Imgs && self.property.assets360Imgs.length > 0) ? self.property.assets360Imgs[0].file_uri : null;
                    break;

                case 'unit_3dmodel_a':
                    self.asset_url = (self.data.unit && self.data.unit.floor_plan_3d) ? self.data.unit.floor_plan_3d : null;
                    if(self.asset_url){
                        self.show3dView(self.data.unit.id, { unit_id: self.data.unit.id, property_type: "unit" });
                    }
                    break;

                case 'unit_360_a':
                    self.asset_url = (self.data.unit && self.data.unit.assets360Imgs && self.data.unit.assets360Imgs.length > 0) ? self.data.unit.assets360Imgs[0].file_uri : null;
                    break;

                default:
                    console.log("Incorrect view mode, do nothing here.");
                    break;
            }
        }

        self.LOADING = false;
    }

    show3dView(id, params) {
        const self = this;

        var url = 'track/view/trackPropertyUnitThreeDView/' + id;

        self.SSHttpService.postAPIRequest(url, params).then(function (responseObj) {
            if (responseObj instanceof Error) {
                console.log(responseObj.message + "\n" + JSON.stringify(responseObj.data));
                return;
            }
        });
    }

}

PropertyLinksController.$inject = ['$scope', '$rootScope', '$localStorage', '$timeout', '$window', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSUserService', 'SSDisclaimerService'];
app.controller('PropertyLinksController', PropertyLinksController);

